import {client} from "./ApiClient";
import {mapServiceUrls} from "../Helpers/Globals";
import {useMutation, useQuery, useQueryClient} from "react-query";

// Response values the Loyalty Engine records on the alert (AlertResponse):
// Acknowledged | Declined | SendText | SendEmail | AwardCoupon | OptOut | TimedOut | Dismissed.
// A call without a Response records Acknowledged only when nothing has been recorded yet.
const acknowledgeAlert = ({urls, accessKey, cartUid, cartExternalId, cartSourceExternalId, alertUid, response, responseCouponCode, responseTransactionUid, keepalive}) => {
    const body = {
        CartUid: cartUid,
        CartExternalId: cartExternalId,
        CartSourceExternalId: cartSourceExternalId,
        AlertUid: alertUid,
    }
    if (response !== undefined && response !== null) {
        body.Response = response
    }
    if (responseCouponCode !== undefined && responseCouponCode !== null) {
        body.ResponseCouponCode = responseCouponCode
    }
    if (responseTransactionUid !== undefined && responseTransactionUid !== null) {
        body.ResponseTransactionUid = responseTransactionUid
    }
    return client(mapServiceUrls(urls).LoyaltyEngineApiUrl, `api/v4/${accessKey}/alerts/commands/acknowledge`, {
        body,
        // keepalive lets the request finish after the snippet window closes or navigates away.
        customConfig: keepalive ? { keepalive: true } : undefined,
    })
}

export default function useAcknowledgeAlert() {
    return useMutation(acknowledgeAlert);
}
